import React from 'react';
import { CheckIcon } from 'lucide-react';
import { valueStack, checkoutUrl, previewImage } from '../data/content';
import { trackPixel } from '../hooks/useMetaPixel';
type OfferStackProps = {
  id?: string;
  title: string;
  priceLabel: string;
  savingsLabel: string;
  ctaLabel: string;
  tone?: 'light' | 'dark';
  showMockup?: boolean;
};
export function OfferStack({
  id,
  title,
  priceLabel,
  savingsLabel,
  ctaLabel,
  tone = 'light',
  showMockup = false
}: OfferStackProps) {
  const isDark = tone === 'dark';
  return <section id={id} className={isDark ? 'bg-lilac-500 py-16 sm:py-20' : 'bg-cream py-16 sm:py-20'} aria-labelledby={`${id ?? 'stack'}-heading`} data-id="element-112" data-mp="1t678o3l3l2i5">
      <div className="mx-auto max-w-2xl px-5" data-id="element-113" data-mp="2252f9gs20elz">
        <h2 id={`${id ?? 'stack'}-heading`} className={`text-center font-display text-3xl font-extrabold sm:text-4xl ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-114" data-mp="2249aglcnnz6h">
          {title}
        </h2>

        {showMockup ? <div className="mt-8" data-id="element-115" data-mp="14o1x3ezp0cwg">
            <div className="overflow-hidden rounded-4xl border-4 border-white shadow-card" data-id="element-116" data-mp="14mzbnml532nx">
              <img src={previewImage} alt="The full kit laid out on a table: box, lookbook, printed dolls, dresses, paper rooms, furniture and a dollhouse" className="h-full w-full object-cover" loading="lazy" data-id="element-117" data-mp="19mbyw8fxabr1" />
            </div>
            <p className={`mt-4 text-center font-display text-lg font-bold ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-118" data-mp="lsbym1qyxynb">
              150+ paper dolls · 30 themes · 3 FREE bonuses
            </p>
          </div> : null}

        <div className="mt-8 rounded-4xl border-2 border-white bg-white p-6 shadow-card sm:p-8" data-id="element-119" data-mp="zrjvgnznsuoc">
          <ul className="divide-y divide-blush-100" data-id="element-120" data-mp="2730xzudhmzwq">
            {valueStack.map(line => <li key={line.title} className="flex items-start justify-between gap-4 py-4" data-id="element-121" data-mp="2b3kseq6ofpf6">
                <span className="text-sm font-semibold leading-snug text-ink/85 sm:text-base" data-id="element-122" data-mp="bz2xggcxr5vh">
                  {line.title}
                </span>
                <span className="shrink-0 font-display font-bold text-ink/50 line-through" data-id="element-123" data-mp="l13sr7olzhui">
                  {line.price}
                </span>
              </li>)}
          </ul>

          <div className="mt-4 flex items-center justify-between border-t-2 border-dashed border-blush-200 pt-4" data-id="element-124" data-mp="3ohsmtu708z3a">
            <span className="font-display text-lg font-bold text-ink" data-id="element-125" data-mp="3kgh2a32zn41y">Total value</span>
            <span className="font-display text-lg font-bold text-ink/50 line-through" data-id="element-126" data-mp="227zpzohl9i9">$85</span>
          </div>

          <div className="mt-3 flex items-center justify-between gap-3 rounded-2xl bg-blush-50 px-4 py-3" data-id="element-127" data-mp="3tgdo7wxztotb">
            <span className="font-display text-lg font-bold leading-tight text-blush-600" data-id="element-128" data-mp="35qjc5hli04a4">
              {priceLabel}
            </span>
            <span className="font-display text-3xl font-extrabold text-blush-500" data-id="element-129" data-mp="30roskdfpiboy">$27</span>
          </div>

          <p className="mt-3 text-center font-display text-base font-bold text-mint-500" data-id="element-130" data-mp="1g8w8hawltj90">
            {savingsLabel}
          </p>

          <a href={checkoutUrl} onClick={() => trackPixel('InitiateCheckout', {
          content_name: 'My Enchanted Paper World',
          value: 27,
          currency: 'USD'
        })} className="mt-6 flex w-full items-center justify-center rounded-full bg-blush-500 px-6 py-5 text-center font-display text-lg font-bold text-white shadow-soft ring-4 ring-blush-200/60 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-blush-600 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-lilac-300 sm:text-xl" data-id="element-131" data-mp="179rac5oyfrxd">
            {ctaLabel}
          </a>

          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs font-semibold text-ink/70 sm:text-sm" data-id="element-132" data-mp="emwp36kbcoiu">
            {['Instant digital access', 'All 3 bonuses included', 'One-time payment'].map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-133" data-mp="u1scjqxedsln">
                  <CheckIcon className="h-4 w-4 text-mint-500" aria-hidden="true" data-id="element-134" data-mp="q101qt8vnfn9" />
                  {item}
                </li>)}
          </ul>
        </div>
      </div>
    </section>;
}